import { render, staticRenderFns } from "./AboutDepartments.vue?vue&type=template&id=563d60f7&scoped=true&"
import script from "./AboutDepartments.vue?vue&type=script&lang=js&"
export * from "./AboutDepartments.vue?vue&type=script&lang=js&"
import style0 from "./AboutDepartments.vue?vue&type=style&index=0&id=563d60f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d60f7",
  null
  
)

export default component.exports